module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"dialog\" title=\"")
    ; __append(escapeFn( subtitle))
    ; __append("\" class=\"forceNotToShrink\" style=\"overflow: hidden;\">\r\n    <div style=\"width:100%; height:100%; overflow: unset;\">\r\n        <table id=\"propMainDataHistory\" style=\"width: 100%;\"></table>\r\n    </div>\r\n</div>")
  }
  return __output;

}